import { SearchSelectItem } from '@td-client-frontend/common';
import { Nullable } from './common';

export enum RegistartionCodes {
  REGISTRATIONDIRECTMAIL = 'REGISTRATIONDIRECTMAIL',
  REGISTRATIONEMAIL = 'REGISTRATIONEMAIL',
  REGISTRATIONPHONE = 'REGISTRATIONPHONE',
  REGISTRATIONTEXTMESSAGE = 'REGISTRATIONTEXTMESSAGE',
  REGISTRATIONTIER = 'REGISTRATIONTIER'
}

export enum RetentionCodes {
  RETENTIONDIRECTMAIL = 'RETENTIONDIRECTMAIL',
  RETENTIONEMAIL = 'RETENTIONEMAIL',
  RETENTIONPHONE = 'RETENTIONPHONE',
  RETENTIONTEXTMESSAGE = 'RETENTIONTEXTMESSAGE',
  RETENTIONTIER = 'RETENTIONTIER'
}

export enum PreferenceCodes {
  COMMUNICATIONLANGUAGE = 'COMMUNICATIONLANGUAGE',
  HEALTHBENEFITLANGUAGE = 'HEALTHBENEFITLANGUAGE',
  PERMISSIONTOTEST = 'PERMISSIONTOTEST'
}

export enum IncentiveCodes {
  INCENTIVEAMAZON = 'INCENTIVEAMAZON',
  INCENTIVEAMEX = 'INCENTIVEAMEX',
  INCENTIVECVS = 'INCENTIVECVS',
  INCENTIVEGOODS = 'INCENTIVEGOODS',
  INCENTIVEMASTERCARD = 'INCENTIVEMASTERCARD',
  INCENTIVEVISA = 'INCENTIVEVISA'
}

export enum CommunicationLanguageOptionsValue {
  ENGLISH_ONLY = 'ENGLISH_ONLY',
  ENGLISH_SPANISH = 'ENGLISH_SPANISH',
  SPANISH_ONLY = 'SPANISH_ONLY',
  ENGLISH_FRANCH = 'ENGLISH_FRANCH',
  FRENCH_ONLY = 'FRENCH_ONLY'
}

export enum HealthBenefitLanguageOptionsValue {
  MADE_AVAILABLE = 'MADE_AVAILABLE',
  BENEFIT_PROVIDED = 'BENEFIT_PROVIDED',
  PROGRAM_PROVIDED = 'PROGRAM_PROVIDED',
  DO_NOT_SHOW = 'DO_NOT_SHOW'
}

export enum ChannelOption {
  YES = 'YES',
  NO = 'NO',
  NOT_PROVIDED = 'NOT_PROVIDED'
}

export enum IncentiveLabel {
  ALL = 'All',
  ALL_MONETARY = 'All Monetary',
  ALL_GOODS_AND_SERVICE = 'All Goods and Services',
  VISA = 'Visa',
  AMEX = 'Amex',
  MASTERCARD = 'Mastercard',
  AMAZON = 'Amazon',
  CVS = 'CVS',
  GOODS = 'Goods'
}

export enum RegistrationAndRetentionFormType {
  REGISTRATION = 'registration',
  RETENTION = 'retention'
}

export interface IncentiveOption {
  name: IncentiveLabel;
  value: ChannelOption;
  label: IncentiveLabel;
}

export interface MarketingPreferencesOption {
  label: string;
  value: string;
  minimumSet?: boolean;
}

export interface RegistrationAndRetentionSettings {
  tier: string;
  email: ChannelOption;
  directMail: ChannelOption;
  phone: ChannelOption;
  textMessage: ChannelOption;
}

export interface IncentiveSettings {
  name: IncentiveLabel;
  value: ChannelOption;
  label: IncentiveLabel;
}

export interface PreferenceSettings {
  communicationLanguage: CommunicationLanguageOptionsValue;
  permissionToTest: ChannelOption;
  healthBenefitLanguage: HealthBenefitLanguageOptionsValue;
  incentive: IncentiveSettings[];
}

export interface ProfileSettings {
  registration: RegistrationAndRetentionSettings;
  retention: RegistrationAndRetentionSettings;
  preferences: PreferenceSettings;
}

export type RegAndRetentionData = Record<RegistrationAndRetentionFormType, RegistrationAndRetentionSettings>;

export interface MarketingProfileById {
  id: string;
  name: string;
  default: boolean;
  affectedOrganizationsCount: number;
  totalComments: number;
  settings: ProfileSettings;
}

export interface MarketingPreferencesRadioButtonsGroup {
  label: string;
  id: string;
  checkedValue: string;
  options: SearchSelectItem[];
}

export enum TabType {
  RegRetention = 'registartionAndRetention',
  Preferences = 'preferences',
  Comments = 'comments'
}

export interface MarketingProfile {
  id: string;
  name?: string;
  default?: boolean;
}

export interface OrganizationProfilesResponse {
  assignedMarketingProfile: Nullable<MarketingProfile>;
  availableMarketingProfiles: MarketingProfile[];
}
export interface PreferenceFormData {
  communicationLanguage: string;
  permissionToTest: ChannelOption;
  healthBenefitLanguage: string;
  incentiveData: IncentiveOption[];
  isBase: boolean;
}

export interface MarketingProfileByIdSettings {
  registration: RegistrationAndRetentionSettings;
  retention: RegistrationAndRetentionSettings;
  preferences: PreferenceSettings;
}

interface Siblings {
  id: number;
}
export interface MarketingExclusion {
  enabledAt: string;
}

export enum MarketingProfileAction {
  EXCLUDE = 'EXCLUDE',
  INCLUDE = 'INCLUDE'
}

export interface MarketingHierarchyRowData {
  assignedMarketingProfile: Nullable<{ id: string }>;
  ancestorMarketingExclusion: Nullable<MarketingExclusion>;
  id: string;
  marketingExclusion: Nullable<MarketingExclusion>;
  marketingProfile: Nullable<MarketingProfile>;
  name: string;
  siblings: Siblings[];
  toManyDescendants?: boolean;
  hiddenSubRows?: boolean;
  group?: {
    id: string;
    legacyGroupId: string;
  };
}

export interface MarketingHierarchyData extends MarketingHierarchyRowData {
  subRows: MarketingHierarchyData[];
}

export interface MarketingSearchResponce {
  isOverflowed: boolean;
  tableData: MarketingHierarchyData[];
}

interface TransformedResponseBase {
  id: string;
  name: string;
  descendants: TransformedResponse[];
  hiddenSubRows?: boolean;
  toManyDescendants?: boolean;
  group?: {
    id: string;
  };
}
type SearchResponse<T> = T & {
  siblings: {
    id: string;
  };
  assignedMarketingProfile: {
    id: string;
  };
  marketingProfile: {
    id: number;
  };
  marketingExclusion: {
    enabledAt: string;
  };
};

type WithAncestors<T> = T & { ancestors: Ancestors[] };
type WithSqlPath<T> = T & { sqlPath: string };
type WithSubRows<T, S = T> = T & { subRows: S[] };

export type OrgDataResponse = WithAncestors<WithSqlPath<TransformedResponseBase>> & { group?: { id: string } };
export type Ancestors = SearchResponse<WithSqlPath<TransformedResponseBase>>;
export type TransformedResponse = WithSubRows<TransformedResponseBase>;
